module.exports = __webpack_public_path__ + "static/media/LI-Logo.e5bd668c.png";